<template>
	<div class="loading-dots">
		<div class="dot"></div>
		<div class="dot"></div>
		<div class="dot"></div>
	</div>
</template>

<script>
	export default {
		name: 'Loading',
	}
</script>

<style lang="scss">
	.loading-dots{
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		
		.dot{
			width: 15px;
			height: 15px;
			background-color: black;
			border-radius: 50%;
			float: left;
			margin: 0 10px;
			transform: scale(0);
			animation: fx 1000ms ease infinite 0ms;
			
			&:nth-child(2) {
				animation: fx 1000ms ease infinite 300ms;
			}
			&:nth-child(3) {
				animation: fx 1000ms ease infinite 600ms;
			}
		}
	}
	
	@-webkit-keyframes fx { 50% {transform: scale(1); opacity: 1; } 100% { opacity: 0; } }
	@keyframes fx { 50% {  transform: scale(1); opacity: 1; } 100% { opacity: 0; } }
</style>
